module.exports = ".int-home-header\r\n{\r\n   color:#0e67b0;\r\n}\r\n.int-horizantal-line\r\n{\r\n    height:3px;\r\n    margin-top:1px;\r\n    background-color:#0e67b0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/internaluserhome/internaluserhome.component.css
// module id = ./src/app/home/internaluserhome/internaluserhome.component.css
// module chunks = main